export const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = (delay = 0, y = 28) => ({
    initial: { opacity: 0, y, filter: "blur(8px)" },
    whileInView: { opacity: 1, y: 0, filter: "blur(0px)" },
    viewport: { once: true, margin: "-80px" },
    transition: { duration: 1.0, delay, ease: EASE },
});

// Lower-cost variant: no blur filter. Use for heavy elements (big images, large cards)
// where blur causes layer-promotion churn during entrance.
export const fadeUpNoBlur = (delay = 0, y = 24) => ({
    initial: { opacity: 0, y },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-80px" },
    transition: { duration: 0.9, delay, ease: EASE },
});

export const staggerContainer = (delayChildren = 0, stagger = 0.08) => ({
    initial: {},
    whileInView: {},
    viewport: { once: true, margin: "-80px" },
    transition: { staggerChildren: stagger, delayChildren },
});

export const child = {
    initial: { opacity: 0, y: 28, filter: "blur(8px)" },
    whileInView: { opacity: 1, y: 0, filter: "blur(0px)" },
    viewport: { once: true, margin: "-80px" },
    transition: { duration: 1.0, ease: EASE },
};
